import { useTenant } from "hooks/settings";
import { useMemo } from "react";
import { useParams } from "react-router";
import { useGetReservedPeriodsQuery } from "src/store/api/generatedApi";

export const useReservations = () => {
  const { location } = useParams<{ location: string }>();
  const tenantName = useTenant();
  const { data } = useGetReservedPeriodsQuery(
    {
      tenantName,
      location: location ?? "",
    },
    {
      skip: !location,
    }
  );
  const reservations = useMemo(() => data?.reservations ?? [], [data]);
  return { reservations, location };
};
